module.exports = __webpack_public_path__ + "img/Jersey.d4e99d54.svg";